import { useSite, resolveMedia } from "../siteContext";

/**
 * Optional decorative background image for any section, set by the admin in
 * المظهر → خلفيات الأقسام. Renders nothing when unset. The overlay keeps text readable
 * and automatically follows the section tone colors the admin picked.
 */
export const SectionBackdrop = ({ id, tone = "dark" }) => {
  const settings = useSite();
  const url = resolveMedia((settings.section_bg || {})[id]);
  if (!url) return null;
  const overlay =
    tone === "light"
      ? "color-mix(in srgb, var(--c-light-bg, #F8F6F0) 84%, transparent)"
      : "color-mix(in srgb, var(--c-bg-alt, #351F44) 80%, transparent)";
  return (
    <div data-testid={`section-bg-${id}`} aria-hidden="true" className="absolute inset-0 pointer-events-none overflow-hidden">
      <img src={url} alt="" className="w-full h-full object-cover" />
      <div className="absolute inset-0" style={{ background: overlay }} />
    </div>
  );
};
